export const repairGuides = [
	{
		title: 'Wymiana żarówki',
		content: [
			'Zaparkuj samochód w bezpiecznym miejscu i wyłącz zapłon.',
			'Otwórz maskę samochodu i zlokalizuj tył reflektora.',
			'Odłącz złącze elektryczne od tyłu żarówki.',
			'Obróć starą żarówkę w lewo, aby ją wyjąć.',
			'Włóż nową żarówkę i obróć ją w prawo, aby ją zamocować.',
			'Ponownie podłącz złącze elektryczne.',
			'Sprawdź światła, aby upewnić się, że nowa żarówka działa poprawnie.',
		],
	},
	{
		title: 'Kontrola ciśnienia opon',
		content: [
			'Zaparkuj samochód na płaskiej powierzchni i aktywuj hamulec ręczny.',
			'Zlokalizuj wentyl na każdej oponie.',
			'Zdejmij nakrętkę wentyla i przyłóż manometr do wentyla.',
			'Sprawdź zalecanie ciśnienia opony w instrukcji samochodu lub na framudze drzwiowej kierowcy.',
			'Jeśli ciśnienie jest niskie, użyj kompresora powietrza, aby napompować oponę do zalecanego poziomu.',
			'Powtórz dla wszystkich opon, również dla koła zapasowego.',
			'Załóż nakrętki wentyla.',
			'Regularnie sprawdzaj ciśnienie opon, aby zapewnić optymalną wydajność paliwa i trwałość opon.',
		],
	},
	{
		title: 'Wymiana oleju',
		content: [
			'Podnieś samochód za pomocą podnośnika lub klinów bezpieczeństwa.',
			'Zlokalizuj śrubę spustową oleju pod silnikiem i odkręć ją, aby odprowadzić zużyty olej.',
			'Odkręć korek olejowy na górze silnika, aby ułatwić spływanie oleju.',
			'Zdemontuj i wymień filtr oleju.',
			'Zamocuj nowy filtr i dokręć śrubę spustową.',
			'Napełnij silnik nowym olejem, sprawdzając poziom za pomocą kija pomiarowego.',
			'Zamontuj korek olejowy.',
			'Sprawdź poziom oleju i uzupełnij, jeśli to konieczne.',
		],
	},
	{
		title: 'Wymiana świecy zapłonowej',
		content: [
			'Odszukaj świecę zapłonową na silniku.',
			'Odkręć przewody zapłonowe z silnika.',
			'Za pomocą klucza zapłonowego, odkręć starą świecę.',
			'Sprawdź jej stan, porównując do wytycznych producenta.',
			'Jeśli świeca jest zużyta, zamień ją na nową.',
			'Wkręć nową świecę, ale nie za mocno.',
			'Podłącz z powrotem przewody zapłonowe.',
			'Powtórz dla pozostałych świec.',
		],
	},
	{
		title: 'Wymiana tarcz i klocków hamulcowych',
		content: [
			'Podnieś samochód i zabezpiecz go klinami.',
			'Otwórz maskę i odłącz przewody hamulcowe od zacisków.',
			'Odkręć śruby mocujące zaciski do tarczy.',
			'Zdejmij zaciski i stary komplet klocków hamulcowych.',
			'Odkręć śruby mocujące tarcze hamulcowe.',
			'Zamontuj nowe tarcze hamulcowe.',
			'Zamocuj nowe klocki hamulcowe do zacisków.',
			'Zamontuj zaciski z nowymi klockami na tarczach.',
			'Podłącz przewody hamulcowe do zacisków.',
			'Powtórz dla drugiego zestawu hamulców na drugim kole.',
		],
	},
	{
		title: 'Wymiana filtru powietrza',
		content: [
			'Znajdź skrzynkę filtra powietrza w silniku.',
			'Otwórz skrzynkę, usuwając zaczepy lub śruby.',
			'Wyjmij stary filtr powietrza.',
			'Sprawdź jego stan, jeśli jest brudny lub zużyty, zamień go na nowy.',
			'Umieść nowy filtr powietrza w skrzynce.',
			'Zamknij skrzynkę i zamocuj zaczepy lub śruby.',
			'Upewnij się, że filtr jest prawidłowo umieszczony.',
		],
	},
	{
		title: 'Naprawa opony',
		content: [
			'Znajdź miejsce, gdzie opona jest przebita.',
			'Odkręć nakrętki wentyla i usuń oponę z pojazdu.',
			'Włóż kawałek linki do otworu w oponie, aby oczyścić trasę dla zakładek.',
			'Wybierz odpowiednią zakładkę do dziury i nałóż klej na jedną stronę.',
			'Włóż zakładkę do dziury za pomocą narzędzi do naprawy opon.',
			'Wyciągnij narzędzie, pozostawiając zakładkę.',
			'Odczekaj, aż klej zaschnie.',
			'Napompuj oponę do zalecanego ciśnienia.',
			'Zamocuj oponę z powrotem na pojeździe.',
		],
	},
	{
		title: 'Wymiana płynu chłodniczego',
		content: [
			'Odczekaj, aż silnik ostygnie.',
			'Otwórz korek zbiornika płynu chłodzącego.',
			'Zlokalizuj kran spustowy z radiatorem i odprowadź stary płyn.',
			'Zamknij kran spustowy i napełnij zbiornik świeżym płynem chłodniczym.',
			'Odpowietrz układ chłodzenia, jeśli to konieczne.',
			'Sprawdź poziom płynu chłodzącego i uzupełnij, jeśli to potrzebne.',
			'Zamknij korek zbiornika.',
		],
	},
	{
		title: 'Wymiana akumulatora',
		content: [
			'Odszukaj akumulator w silniku.',
			'Odczekaj, aż silnik ostygnie.',
			'Odłącz czarny kabel (ujemny) od akumulatora.',
			'Odłącz czerwony kabel (dodatni) od akumulatora.',
			'Poluzuj śruby mocujące akumulatora.',
			'Wyjmij stary akumulator.',
			'Umieść nowy akumulator i dokręć śruby mocujące.',
			'Podłącz czerwony kabel (dodatni), a następnie czarny kabel (ujemny).',
			'Sprawdź, czy akumulator jest prawidłowo zamocowany.',
		],
	},
	{
		title: 'Wymiana kierownicy',
		content: [
			'Podnieś przednią część pojazdu i zabezpiecz go klinami.',
			'Odkręć nakrętkę kierownicy i usuń kierownicę.',
			'Odkręć śruby mocujące złącza kierownicy.',
			'Usuń stare złącze kierownicy.',
			'Zamocuj nowe złącze kierownicy i dokręć śruby mocujące.',
			'Przywróć kierownicę na miejsce i dokręć nakrętkę.',
			'Upewnij się, że kierownica jest zamocowana bez luzów.',
		],
	},
	{
		title: 'Wymiana żarówek świateł stopu',
		content: [
			'Poproś kogoś o pomoc do sprawdzenia działania świateł stopu.',
			'Otwórz bagażnik i zlokalizuj tył lampy hamulcowej.',
			'Odkręć śruby mocujące lampę hamulcową.',
			'Wyjmij stare żarówki hamulcowe.',
			'Włóż nowe żarówki hamulcowe.',
			'Zamocuj lampę hamulcową, dokręcając śruby.',
			'Poproś pomocnika o ponowne sprawdzenie działania świateł stopu.',
		],
	},
]
